import { CallService } from '../../../../entities/Call/service';
import { CallTranscriptMessageService } from '../../../../entities/CallTranscriptMessage/service';
import { CallToneSuggestionService } from '../../../../entities/CallToneSuggestion/service';
import { CallSummaryService } from '../../../../entities/CallSummary/service';
import { CallWhatToSaySuggestionService } from '../../../../entities/CallWhatToSaySuggestion/service';
import { CostLogService } from '../../../../entities/CostLog/service';
import { EventsService } from '../../../../entities/Events/service';

// Create service instances once at module initialization
export const callService = new CallService();
export const callTranscriptMessageService = new CallTranscriptMessageService();
export const callToneSuggestionService = new CallToneSuggestionService();
export const callSummaryService = new CallSummaryService();
export const callWhatToSaySuggestionService = new CallWhatToSaySuggestionService();
export const costLogService = new CostLogService();
export const eventsService = new EventsService();
